import React from "react"

export const Footer = () => {
  return (
    <footer className="flex flex-col px-16 py-12 bg-[#FFD000] gap-4">
      <h1 className="font-bold text-5xl">YOUR ISSUE</h1>
      <span className="text-2xl font-light">
        Kabar Palmerah About Us Advertise Policy Pedoman Media Siber Career
        Contact Us <br /> Copyright 2008 - 2021 PT. Kompas Cyber Media (Kompas
        Gramedia Digital Group). All rights reserved.a
      </span>
    </footer>
  )
}
